<script>
  import { modal, tabs, tab } from 'vue-strap';
  import Vue from 'vue';
  import FileInput from '~componentes/InputFile.vue'
  import converterObjetoFormData from '~js/converter-objeto-formdata';
  import lancamentoServico from '~modulos/lancamento/servico';
  
  export default {
    components: { modal, tabs, tab, FileInput },
    props: {
      mostrar: {
        type: Boolean,
        required: true,
      },
      id: {
        required: true,
      },
    },
    data() {
      return {
        arquivos: [],
        arquivosInterno: new Array(5),
        carregando: true,
        fazendoUpload: false,
        possuiArquivoSol : false,
        mostrarDropzone: false,
      }
    },
    methods: {
      url() {
        return `/api/lancamento/${this.id}/arquivos`;
      },
      lista() {
        let promise = null;
        this.carregando = false;

        promise = lancamentoServico.arquivos(this.id, true);

        promise
          .then(arquivos => {
            this.arquivos = arquivos;
            this.possuiArquivoSol = (arquivos.length > 0); 
            this.carregando = false;
          })
      },
      download(arquivo) {
        arquivo = this.nomeArquivo(arquivo)
        let promise = null;

        promise = lancamentoServico.download(this.id, arquivo);

        promise
          .then(arquivo => {
            arquivo.download();
          });
      },
      carregar() {
        this.lista();
        //this.limparArquivos();
        this.arquivosInterno = new Array(5);
        this.fazendoUpload = false;
        $('#upload').button('reset');
      },
      nomeArquivo(arquivo) {
        return arquivo.slice(arquivo.lastIndexOf('\\') + 1);
      },
      adicionarArquivo() {
        this.arquivosInterno.push(null);
      },
      limparArquivos() {
        this.deletados = [];

        while (this.arquivosInterno.length != 0) {
          this.arquivosInterno.pop();
        }

        for (var i = 0; i < 5; i++) {
          this.adicionarArquivo();
          this.$refs.fileInput[i].removerArquivo();
        }
      },
      existeArquivo() {
        let existeArquivo = false;
        for (let arquivo of this.arquivosInterno) {
          if (arquivo) {
            existeArquivo = true;
            break;
          }
        }
        return existeArquivo;
      },
      emitChanges() {

        let a = []
        for (let arquivo of this.arquivosInterno) {
          if (arquivo) {
            a.push(arquivo.name)
          }
        }
        this.$emit('input', a);
      },
    },
    computed: {
      show() {
        return this.mostrar;
      },
    },
    mounted() {

    }
  }
</script>

<template>
  <div>

    <modal ref="modal"
           :value="show"
           effect="fade"
           @closed="mostrarDropzone = false, arquivos = [], $emit('fechado')"
           @opened="carregar"
           :large="true">
      <div slot="modal-header" class="modal-header">Arquivos Financeiro</div>

      <tabs :nav-style="'tabs'" :justified="true">
        <tab header="Arquivos">

          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Nome do arquivo</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="arquivo in arquivos">
                  <td>{{ nomeArquivo(arquivo.replace("_PROTOCOLO", "")) }}</td>
                  <td class="action">
                    <button type="button"
                            class="btn btn-default btn-xs"
                            @click="download(arquivo)">
                      <i class="fa fa-download"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="arquivos.length === 0 && !carregando">
                  <td colspan="2" class="text-center">Nenhum arquivo encontrado.</td>
                </tr>
                <tr v-show="carregando">
                  <td colspan="2">
                    <i class='fa fa-spinner fa-pulse'></i> Carregando...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </tab>
      </tabs>

      <div slot="modal-footer" class="modal-footer">
        <button type="button"
                class="btn btn-default"
                @click="$refs.modal.action(false, 3)">
          <i class="fa fa-times"></i> Fechar
        </button>
      </div>
    </modal>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/ModalArquivosLancamento.vue